import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Participant } from 'src/app/shared/models/Participant';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { WsAttendanceKey } from 'src/app/shared/models/WsAttendanceKey';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
@Component({
  selector: 'app-workshop-participant',
  templateUrl: './workshop-participant.component.html',
  styleUrls: ['./workshop-participant.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopParticipantComponent implements OnInit {

  date1: Date;
  cities: any[];
  value1: number;
  disabled: boolean;

  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  workShopDetail: any;
  listParticipant: Participant[];
  selectedParticipant: Participant;
  dataParent: any;
  blocked: boolean = true;

  lbl_part1: string;
  lbl_part2: string;

  lbl_go_Back: string = "back_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_record_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_confirm: string = "confirm_";
  lbl_loading: string ="loading_";


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
      });

    if (this.dataParent) {

    } else {
      this.redirectWorkShop();
    }


  }

  ngOnInit(): void {
    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.workShopDetail = this.dataParent.workshop;
      this.getTranslatedLabels();
    } else {
    }
    this.getSecurity();

  }

  redirectWorkShop() {

    let queryParamsDetail = {}
    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }
    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail
    }

    this.router.navigate(['guide/workshops'], navigationExtras);
  }

  redirectParticipantDetail(participantSel: any) {
    let queryParamsDetail = {}
    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }
    let obj = {
      participant: participantSel,
      security: this.security,
      workshop: this.workShopDetail
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['guide/workshopsParticipantDetail'], navigationExtras);
  }

  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;

          this.loadParticipants();

        });
    } else {
      this.loadParticipants();

    }
    this.changeDescription();


  }



  loadParticipants() {
    this.blocked = true;
    this.apiService.getParticipantsByServices(this.workShopDetail.f0.wrksId).then(
      participants => {
        this.blocked = false;
        this.listParticipant = participants;

      }).finally(()=>{});

  }

  deleteParticipant(participantSel: any) {
    this.confirmationService.confirm({
      message: '¿ ' +this.lbl_are_you_sure +' '+  this.lbl_delete +' '+ this.lbl_participants+ ' ?',
      header: this.lbl_confirm +' '+ this.lbl_delete,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteParticipantService(participantSel);
      }
    });
  }

  deleteParticipantService(participantSel: any) {


    this.apiService.deleteParticipantForm0({
      id: participantSel.particiId,
      wrksId: this.workShopDetail.f0.wrksId,
      language: this.security.language
    }).then(
      data => {
        if (data != null && data.status == 'OK') {
          this.messageService.add({ severity: 'success', summary: 'Eliminar Participante', detail: 'Se elimino participante correctamente', life: 3000 });
          this.loadParticipants();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Eliminar Participante', detail: data.errorMessage, life: 9000 });
        }
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Eliminar Participante', detail: error, life: 3000 });
      });
  }

  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_church_name, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_are_you_sure, this.lbl_confirm,this.lbl_loading]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_search);
        this.lbl_participants_12 = map.get(this.lbl_search);
        this.lbl_participants_1st = map.get(this.lbl_search);
        this.lbl_future_guide = map.get(this.lbl_search);
        this.lbl_partic_partner = map.get(this.lbl_search);
        this.lbl_no_sent = map.get(this.lbl_search);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_loading = map.get(this.lbl_loading);


      });
  }

  changeDescription() {
    this.lbl_part1 = this.lbl_particp15s;
    this.lbl_part2 = this.lbl_participants_12;

  }


  exportExcel() {
    if (this.listParticipant === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listParticipant.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listParticipant.map((item) => {
        return {
          "NOMBRE": item.name || 'S/N',
          "APELLIDO": item.lastName || 'S/N',
          "TELEFONO": item.mobPhon || 'S/N',
          "EMAIL": item.email || 'S/N',
          "GENERO": item.gender || 'S/N',
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listServicesParticipant_');

    }
  }



  exportPdf() {
    if (this.listParticipant === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listParticipant.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listParticipant.map((item) => {
        return {
          "NOMBRE": item.name || 'S/N',
          "APELLIDO": item.lastName || 'S/N',
          "TELEFONO": item.mobPhon || 'S/N',
          "EMAIL": item.email || 'S/N',
          "GENERO": item.gender || 'S/N',
        };
      });

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listServicesParticipant_');

    }
  }


  canEdit() {
    if (this.workShopDetail.f0.status === 'A' || this.workShopDetail.f0.status === 'P') {
      return false;
    } else {
      return true;
    }
  }
}
